let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("epeUg")).then(() => parcelRequire('5zvIl'));